import { render, staticRenderFns } from "./CreationTime.vue?vue&type=template&id=4fca06ab&scoped=true"
import script from "./CreationTime.vue?vue&type=script&lang=js"
export * from "./CreationTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fca06ab",
  null
  
)

export default component.exports